import type React from 'react'

import { lexicalHasContent } from '@/app/buy/seller/[sellerSlug]/content/cmsSellerProfileAbout'

import type { CmsTermsBody } from '../cmsTerms'
import { AttPolicyPoints } from './AttPolicyPoints'
import { CmsTermsPoints } from './CmsTermsPoints'
import { isAttStorefront, isSumitomoStorefront } from './storefrontSlugs'
import { SumitomoTermsPoints } from './SumitomoTermsPoints'

// The storefront-specific policy points shown on the terms-acceptance screen,
// between the description and the action buttons. A CMS body wins when an
// editor wrote one; otherwise the hardcoded sets by slug, so AT&T and Sumitomo
// keep their bullets until replacements are typed. Returns null when the
// storefront has neither. Shared by the LDP and the seller storefront page so
// the two stay in sync.
export const getTermsPoints = ({
  sellerSlug,
  termsDocUrl = '#',
  termsDisplayName = 'Terms of Purchase',
  cmsTerms,
}: {
  sellerSlug: string | null | undefined
  termsDocUrl?: string
  termsDisplayName?: string
  cmsTerms?: CmsTermsBody | null
}): React.ReactNode => {
  if (cmsTerms && lexicalHasContent(cmsTerms)) {
    return <CmsTermsPoints body={cmsTerms} />
  }

  if (isAttStorefront(sellerSlug)) {
    return (
      <AttPolicyPoints
        termsDisplayName={termsDisplayName}
        termsDocUrl={termsDocUrl}
      />
    )
  }

  if (isSumitomoStorefront(sellerSlug)) return <SumitomoTermsPoints />

  return null
}
